import React from "react"; // eslint-disable-line no-unused-vars
import Layout from "./src/containers/layout";
import { ThemeProviderWrapper } from "./src/theme/ThemeContext";
import { CacheProvider } from "@emotion/react";
import { myCache } from "./src/theme/emotion-cache";

/**
 * Load the Personal Analytics tracking script
 * Called when the initial client render completes
 */
export const onClientEntry = () => {
  // Only load tracking script in the browser
  if (typeof window !== "undefined") {
    loadTrackingScript();
  }
};

/**
 * Track route changes for SPA navigation
 * The tracking script automatically handles route changes via history API,
 * but this hook is available for custom logic if needed
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Pageviews are tracked automatically by the tracking script
  // which monitors history.pushState and history.replaceState
  // This function is included for reference if you need custom logic
};

/**
 * Loads the tracking script from the Personal Analytics server
 */
function loadTrackingScript() {
  // Check if script is already loaded
  const existingScript = document.querySelector('script[src*="fb-a7k2"]');
  if (existingScript) {
    return;
  }

  // Create script element
  const script = document.createElement("script");

  // Load from environment variable (defaults to production URL)
  script.src =
    process.env.GATSBY_ANALYTICS_URL || "https://analytics.franksblog.nl/fb-a7k2.js";

  script.async = true;
  script.defer = true;

  // Optional: Handle successful load
  script.onload = () => {
    console.log("Personal Analytics tracking loaded");
  };

  // Optional: Handle load errors
  script.onerror = () => {
    console.warn("Failed to load Personal Analytics tracking script");
  };

  // Append to document head
  document.head.appendChild(script);
}

// Wraps every page in a component
export const wrapPageElement = ({ element }) => {
  return <Layout>{element}</Layout>;
};
// Wraps the root element in a component
export const wrapRootElement = ({ element }) => {
  return (
    <CacheProvider value={myCache}>
      <ThemeProviderWrapper element={element} />
    </CacheProvider>
  );
};
